export default __webpack_public_path__ + "static/media/profile-pic.7fe75e05.jpg";